export default __webpack_public_path__ + "static/media/moodboard-milieu-terrestre.1b7a541d.pdf";